import "./ChatboxTextBased.css";
import { isNull } from "lodash";
import UserHeader from "../header/UserHeader";
import UserDrawer from "../drawer/UserDrawer";
import { SendOutlined } from "@ant-design/icons";
import { postRequest, getRequest } from "../../api";
import samImage from '../../assets/images/Sam_Logo.png';
import React, { useState, useEffect, useRef } from "react";
import goBackButton from "../../assets/images/Go_Back.svg";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, Input, Card, Col, Row, Typography, notification } from "antd";
import { getScriptStatus } from "../../api/password.js";
import { generateSessionId, displayCustomiseFirstMessageInGTKY } from "./ChatBoxUtilities.js";
import { gettingToKnowYou, gettingToKnowYouResumePrompt, socialMedia, getUserName, myFriendScripts } from "../../constants/constants";
import { getUserBots } from "../../api/Avatar.js";

const ChatboxTextBased = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const chatboxRef = useRef(null);
    const promptsRef = useRef(null);
    const conversationRef = useRef(null);
    const botMessageContent = useRef(null);
    const promptTypePayload = useRef(null);
    const isScriptCompleted = useRef(false);
    const utterancePromptsPayload = useRef(null);
    const [messages, setMessages] = useState([]);
    const [botsData, setBotsData] = useState({});
    const userId = localStorage.getItem("userid");
    const saveConversationTriggered = useRef(false);
    const [sessionId, setSessionId] = useState(null);
    const [startTime, setStartTime] = useState(null);
    const gettingToKnowResumeConversation = useRef();
    const [isLoading, setIsLoading] = useState(false);
    const [inputMessage, setInputMessage] = useState("");
    const [redFlagWords, setRedFlagWords] = useState([]);
    const [firstMessage, setFirstMessage] = useState(true);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const queryParams = new URLSearchParams(location.search);
    const conversationType = queryParams.get("type");
    const [sessionActive, setSessionActive] = useState(false);
    const [responseReceived, setResponseReceived] = useState(true);
    const [gettingToKnowResume, setGettingToKnowResume] = useState(null);
    const [user, setUser] = useState({ botName: '', name: '', speechSpeed: '', country: '', city: '', gender: '', hobbies: [] });

    const fetchBotsData = async () => {
        try {
            const response = await getUserBots();
            if (response.success) {
                setBotsData(response.data.reduce((acc, { botName, imageUrl }) => {
                    acc[botName] = imageUrl;
                    return acc;
                }, {}));
            }
        } catch (error) {
            console.error('Error fetching bot data:', error);
            notification.error({
                message: 'Error fetching bot data',
                description: error.message,
            });
        }
    };

    useEffect(() => {
        fetchBotsData();
    }, []);

    const fetchRedFlagWords = async () => {
        try {
            const response = await getRequest('/conversation/redflag_name');
            if (response) {
                setRedFlagWords(response.redFlagWords || []);
            }
        } catch (err) {
            console.error("Error fetching red flag words:", err);
        }
    };

    useEffect(() => {
        fetchRedFlagWords();
    }, []);

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const response = await getRequest('/user');
                const avatar = response.chooseAvatar;
                const botName = avatar === 'Arthur' || avatar === 'Amy' || avatar === 'Sam' ? avatar : 'Amy';
                setUser({
                    botName,
                    speechSpeed: response.voiceSpeed,
                    name: response.name,
                    nickName: response.nickName,
                    country: response.country,
                    city: response.city,
                    gender: response.gender,
                    hobbies: response.hobbies
                });
            } catch (error) {
                console.error("Error Fetching User:", error);
                setUser({
                    botName: 'Amy',
                    speechSpeed: '',
                    name: '',
                    nickName: '',
                    country: '',
                    city: '',
                    gender: '',
                    hobbies: []
                });
            }
        };
        fetchUser();
    }, []);

    useEffect(() => {
        if (chatboxRef.current) {
            chatboxRef.current.scrollTop = chatboxRef.current.scrollHeight;
        }
    }, [messages]);

    useEffect(() => {
        generateSessionId(setSessionId);
        checkGettingToKnowYouScriptStatus();
    }, []);

    useEffect(() => {
        if (sessionId && !isNull(gettingToKnowResume) && user.botName) {
            checkWhichPromptToLoad();
        }
    }, [sessionId, gettingToKnowResume, user.botName]);

    const checkConversationForRedFlags = (conversation) => {
        const userMessages = conversation.filter(msg => msg.role === "user");
        for (const message of userMessages) {
            try {
                const parsedContent = JSON.parse(message.content);
                const messageText = parsedContent.message || "";
                
                const words = messageText.toLowerCase().split(/\s+/);
                
                if (redFlagWords.some(flagWord => 
                    words.includes(flagWord.toLowerCase())
                )) {
                    return "red";
                }
            } catch (error) {
                console.error("Error parsing message content:", error);
            }
        }
        return "none";
    };

    const openConversationfirstMessage = `Hi ${getUserName()}, we are back again, what would you like to talk about today?`;

    const checkGettingToKnowYouScriptStatus = async () => {
        try {
            const response = await getScriptStatus();
            if (response.conversationCompleted === true) {
                promptTypePayload.current = "open-conversation";
            } else if (response.conversationCompleted === false) {
                const conversationArray = response?.conversation;
                if (conversationArray && conversationArray.length > 1) {
                    const modifiedArray = conversationArray.slice(1);
                    gettingToKnowResumeConversation.current = modifiedArray;
                } else {
                    gettingToKnowResumeConversation.current = conversationArray;
                }
                setGettingToKnowResume(true);
            }
        } catch (err) {
            console.log("In catch", err);
            setGettingToKnowResume(false);
        }
    };

    const createResumeScriptPrompt = (user) => {
        let conversationArray = gettingToKnowResumeConversation.current;

        const systemPromptExists = conversationArray.some(
                prompt => prompt.role === "system"
        )
        
         if (!systemPromptExists) {
            let systemPrompt = gettingToKnowYou(user);
              conversationArray = [systemPrompt["prompts"][0], ...conversationArray];
          }
        
        const newResumePrompt = {
            prompts: conversationArray?.concat(gettingToKnowYouResumePrompt(user))
        };
        return newResumePrompt;
    };

    const checkWhichPromptToLoad = () => {
        if (conversationType === "gettingToKnowYou") {
            if (gettingToKnowResume) {
                promptsRef.current = createResumeScriptPrompt(user);
                utterancePromptsPayload.current = createResumeScriptPrompt(user);
            } else {
                promptsRef.current = gettingToKnowYou(user);
                utterancePromptsPayload.current = gettingToKnowYou(user);
            }
        } else if (conversationType === "openConversation") {
            promptsRef.current = socialMedia;
            utterancePromptsPayload.current = socialMedia;
        }
    };

    const setMessagesContent = (currentBotName) => {
        if (
            displayCustomiseFirstMessageInGTKY(
                firstMessage,
                promptTypePayload.current,
                gettingToKnowResume
            )
        )
            return `Hi there! I'm ${currentBotName}, and it's great to meet you. I'm here to help. My job involves listening and supporting you and helping you navigate life's challenges.`;
        else if (firstMessage && promptTypePayload.current === "open-conversation")
            return openConversationfirstMessage;
        else return botMessageContent.current;
    };

    const updateMessage = () => {
        setMessages((prev) => [
            ...prev,
            {
                content: setMessagesContent(user.botName),
                timestamp: new Date(),
                isUser: false,
            },
        ]);
    };

    const removeMiscellaneousText = (text) => {
        if (!text) {
            return "";
        }
        let cleanedText = text
            .replace(
                /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g,
                ""
            )
            .trim();
        cleanedText = cleanedText.replace(/^(Kano\s*:?"?\s*)/, "");
        return cleanedText;
    };

    const sanitizeJsonString = (jsonString) => {
        let sanitized = jsonString.replace(/[\u0000-\u001F\u007F-\u009F`]/g, "").trim();
        return sanitized;
    };

    const jsonFormatter = (item) => {
        try {
            const sanitizedContent = sanitizeJsonString(item.content);
            const parsedContent = JSON.parse(sanitizedContent);

            if (parsedContent.message) {
                return removeMiscellaneousText(parsedContent.message);
            } else {
                return removeMiscellaneousText(JSON.stringify(parsedContent));
            }
        } catch (error) {
            return removeMiscellaneousText(item.content);
        }
    };

    const getBotReply = async () => {
        try {
            setResponseReceived(false);
            const response = await postRequest(
                `${process.env.REACT_APP_API_URL}/openai/conversation`,
                { prompts: promptsRef.current.prompts, type: promptTypePayload.current }
            );

            let botMessage = response[0].message.content;
            if (saveConversationTriggered.current) return;

            try {
                const parsedContent = JSON.parse(botMessage);
                botMessageContent.current = jsonFormatter({ content: botMessage });

                if (parsedContent.conversation_end) {
                    setSessionActive(false);
                    saveConversation();
                }
                if (parsedContent?.asked_all_questions) {
                    isScriptCompleted.current = true;
                }
            } catch (e) {
                botMessageContent.current = removeMiscellaneousText(botMessage);
            }

            promptsRef.current = {
                ...promptsRef.current,
                prompts: [
                    ...promptsRef.current.prompts,
                    {
                        role: "assistant",
                        content: botMessage,
                    },
                ],
            };

            utterancePromptsPayload.current = {
                ...utterancePromptsPayload.current,
                prompts: [
                    ...utterancePromptsPayload.current.prompts,
                    {
                        role: "assistant",
                        content: botMessage,
                        time: new Date().toISOString(),
                    },
                ],
            };

            if (!conversationRef.current) {
                conversationRef.current = { prompts: [] };
            }

            conversationRef.current.prompts = [
                ...conversationRef.current.prompts,
                {
                    role: "assistant",
                    content: botMessage,
                },
            ];

            updateMessage();
            setResponseReceived(true);
        } catch (error) {
            console.error("Error getting bot reply: ", error);
            setResponseReceived(true);
        }
    };

    const handleSendMessage = async () => {
        if (inputMessage.trim() === "" || !sessionActive) return;

        const userMessage = {
            content: inputMessage,
            isUser: true,
            timestamp: new Date(),
        };

        setMessages((prevMessages) => [...prevMessages, userMessage]);
        setInputMessage("");
        setIsLoading(true);

        try {
            if (!promptsRef.current) {
                console.error("promptsRef.current is null. Initializing it.");
                promptsRef.current = { prompts: [] };
            }

            promptsRef.current = {
                ...promptsRef.current,
                prompts: [
                    ...promptsRef.current.prompts,
                    { role: "user", content: `{ "message": "${inputMessage}"}` },
                ],
            };

            utterancePromptsPayload.current = {
                ...utterancePromptsPayload.current,
                prompts: [
                    ...utterancePromptsPayload.current.prompts,
                    {
                        role: "user",
                        content: `{ "message": "${inputMessage}"}`,
                        time: new Date().toISOString(),
                    },
                ],
            };

            if (!conversationRef.current) {
                conversationRef.current = { prompts: [] };
            }

            conversationRef.current.prompts = [
                ...conversationRef.current.prompts,
                {
                    role: "user",
                    content: `{ "message": "${inputMessage}"}`,
                    time: new Date().toISOString(),
                },
            ];

            await getBotReply();
        } catch (error) {
            console.error("Error getting bot reply: ", error);
        } finally {
            setIsLoading(false);
        }
    };

    const startSession = () => {
        setSessionActive(true);
        setStartTime(new Date().toLocaleTimeString("en-US", { timeZone: "America/New_York" }));
        setFirstMessage(false);
        getBotReply();
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            handleSendMessage();
        }
    };

    const handleStartSession = async () => {
        startSession();
    };

    const saveConversation = async () => {
        setResponseReceived(false);
        saveConversationTriggered.current = true;
        try {
            setSessionActive(false);
            const conversationFlag = checkConversationForRedFlags(conversationRef.current.prompts);
            const conversationData = {
                Conversation: conversationRef.current.prompts,
                userId: userId,
                userName: user.name,
                startTime: startTime,
                scriptTitle: myFriendScripts[0].title,
                conversationCompleted: false,
                flag: conversationFlag
            };

            await postRequest(
                `${process.env.REACT_APP_API_URL}/conversation/utterance`,
                conversationData
            );

            navigate("/ending-page", { state: { botName: user.botName } });
        } catch (error) {
            console.error("Error saving conversation: ", error);
            navigate("/ending-page", { state: { botName: user.botName } });
        }
    };

    const handleEndSession = () => {
        setSessionActive(false);
        saveConversation();
    };

    const openDrawer = () => {
        setIsDrawerOpen(true);
    };

    const closeDrawer = () => {
        setIsDrawerOpen(false);
    };

    const handleBack = () => {
        navigate("/landing-page");
    };

    return (
        <div style={{ minHeight: "100dvh", overflow: "hidden", background: "#fefcfe" }}>
            <Col xs={24} sm={24} lg={24} md={24} style={{
                transition: "opacity 0.3s ease, pointer-events 0.3s ease",
                opacity: isDrawerOpen ? "0.5" : "1",
                pointerEvents: isDrawerOpen ? "none" : "auto",
            }}>
                <Row justify={{ xs: "space-around", md: "space-around", lg: "space-between" }} style={{ marginBottom: 20 }}>
                    <Col xs={{ span: 22 }} lg={{ span: 24 }} md={{ span: 22 }}>
                        <UserHeader setDrawer={openDrawer} />
                    </Col>
                    {isDrawerOpen && (
                        <Col span={4}>
                            <UserDrawer isDrawerOpen={isDrawerOpen} onClose={closeDrawer} />
                        </Col>
                    )}
                </Row>
                <button onClick={handleBack} className="text-left pl-4 button-styling setBackButton">
                    <img src={goBackButton} alt="Go Back Button" />
                </button>

                <div className="chat-component">
                    <div className="chatbox-container">
                        <Card title={
                            <div className="card-header">
                                <img src={botsData['Sam'] ? botsData['Sam'] : samImage} className="chat-image" style={{ borderRadius: '50%' }} />
                                <Typography className="chat-text">Chat with Sam</Typography>
                            </div>
                        }>
                            <div className="chatbox-messages" ref={chatboxRef}>
                                {messages.map((message, index) => (
                                    <div
                                        key={index}
                                        className={`message ${message.isUser ? "user" : "bot"}`}
                                    >
                                        <p className={`name ${message.isUser ? "user" : "bot"}`}>
                                            {message.isUser ? `${user.name}` : "Sam"}
                                        </p>
                                        <p className={`content ${message.isUser ? "user" : "bot"}`}>
                                            {message.isUser ? message.content : jsonFormatter({ content: message.content })}
                                        </p>
                                        <small className="timestamp-bold">
                                            {message.timestamp.toLocaleTimeString()}
                                        </small>
                                    </div>
                                ))}
                                {isLoading && <div className="loading">{user.botName} is typing...</div>}
                            </div>
                            <div className="chatbox-input">
                                <Input.TextArea
                                    value={inputMessage}
                                    onChange={(e) => setInputMessage(e.target.value)}
                                    onKeyPress={handleKeyPress}
                                    placeholder="Type your message here..."
                                    autoSize={{ minRows: 1, maxRows: 4 }}
                                    disabled={!sessionActive}
                                    className="input-area"
                                />
                                <Button
                                    type="primary"
                                    icon={<SendOutlined />}
                                    onClick={handleSendMessage}
                                    disabled={isLoading || !sessionActive}
                                    className="send-button"
                                >
                                    Send
                                </Button>
                            </div>
                        </Card>
                        <div className="chatbox-controls">
                            <Button
                                onClick={sessionActive ? handleEndSession : handleStartSession}
                                disabled={!responseReceived}
                                className="border-radius-start-end-session"
                                style={{
                                    background: !responseReceived
                                        ? "#ddd"
                                        : sessionActive
                                            ? "#ff007f"
                                            : "#ff007f",
                                    color: !responseReceived ? "#aaa" : "white",
                                    margin: "0 auto",
                                    display: "block",
                                }}
                            >
                                {sessionActive ? "End Session" : "Start Session"}
                            </Button>
                        </div>
                    </div>
                </div>
            </Col>
        </div>
    );
};

export default ChatboxTextBased;